import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, SvgIcon, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { ArrowRight } from '@/utils/iconSVG';

import {
  stylesBoxChoice,
  stylesBoxChoiceList,
  stylesBoxChoiceHeading,
  stylesBoxChoiceContent,
  stylesBoxChoiceBtnIcon,
  stylesBoxChoiceListItem,
  stylesBoxChoiceSubDescription,
} from './BoxChoice.styles';

type BoxChoiceProps = {
  disabled?: boolean;
  description?: string;
  subDescription?: string;
  heading: React.ReactNode;
  items: (string | React.ReactElement)[];
  onSelectAnOffer?: () => void;
};
export const BoxChoice: React.FunctionComponent<BoxChoiceProps> = ({
  items,
  heading,
  disabled,
  description,
  subDescription,
  onSelectAnOffer,
}) => {
  const { t } = useTranslation('customsPass_servicesOffer');

  const handleSelectAnOffer = () => {
    if (disabled) {
      return;
    }

    onSelectAnOffer();
  };
  return (
    <>
      <Box
        data-testid='box-choice'
        onClick={handleSelectAnOffer}
        sx={{ ...stylesBoxChoice }}
        className={disabled && 'disabled'}
      >
        <Box component='span' sx={stylesBoxChoiceHeading}>
          {heading}
        </Box>
        <Typography mt={2}>{description}</Typography>
        <Box sx={stylesBoxChoiceContent}>
          {subDescription && <Typography sx={stylesBoxChoiceSubDescription}>{subDescription}</Typography>}
          <ListItems items={items} />
        </Box>
        <Box component='span' pt={5} width='100%'>
          <Button size='large' variant='contained' color='primaryLight' disabled={disabled} fullWidth>
            {t('customsPass.servicesOffer.chooseButton.label')}
            <SvgIcon component={ArrowRight} color='info' data-testid='svg-icon' sx={stylesBoxChoiceBtnIcon} />
          </Button>
        </Box>
        {/* {disabled && (
          <Typography variant='h2' component='div' sx={stylesBoxChoiceComingSoon}>
            {t('customsPass.servicesOffer.servicesType.notAvailable')}
          </Typography>
        )} */}
        {/* {t('customsPass.servicesOffer.servicesType.comingSoon')} */}
      </Box>
    </>
  );
};

const ListItems: React.FunctionComponent<{ items: (string | React.ReactElement)[] }> = ({ items }) => (
  <List sx={stylesBoxChoiceList}>
    {items.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ListItem key={index} sx={stylesBoxChoiceListItem}>
        {/* <SvgIcon color='info' component={ChevronDownIcon} data-testid='svg-icon' sx={stylesBoxChoiceListItemIcon} /> */}
        {item}
      </ListItem>
    ))}
  </List>
);
